// extracted by mini-css-extract-plugin
export default {"btnSection":"styles_btnSection__b-6Xf","ReturnBtn":"styles_ReturnBtn__b2R31","HomeBtn":"styles_HomeBtn__F8NV3"};